import { render, staticRenderFns } from "./historyOrder.vue?vue&type=template&id=54540899&scoped=true&"
import script from "./historyOrder.vue?vue&type=script&lang=ts&"
export * from "./historyOrder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54540899",
  null
  
)

export default component.exports